export default "__VITE_ASSET__B8c6n9o0__"